import { Component, OnInit } from '@angular/core';
import { PROVINCES } from '../../../data/provinces';
import { Manufacturer } from '../../../../classes/Manufacturer';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-add-manufacturer',
  templateUrl: './add-manufacturer.component.html',
  styleUrls: ['./add-manufacturer.component.css']
})
export class AddManufacturerComponent implements OnInit {

  provinces = PROVINCES;

  isSubmitButtonDisabled: boolean = false;
  newManufacturer: Manufacturer = new Manufacturer( );
  addEmailButtonDisabled: boolean = true;
  
  availableRoles: string[] = [ 'admin' ];
  isAvailable: boolean = true;

  selectParams: any = {
    billingState: {
      id: 'inputBillingState',
      isRequired: true,
      change: ( event ) => {
        this.newManufacturer.billingState = event.value;
      },
      options: [ { text: '', value: '' } ]
    },
    shippingState: {
      id: 'inputShippingState',
      isRequired: true,
      change: ( event ) => {
        this.newManufacturer.shippingState = event.value;
      },
      options: [ { text: '', value: '' } ]
    }
  };

  constructor ( 
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Add Manufacturer' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
    this.newManufacturer.emails = [ '' ];


    this.provinces.forEach( _state => {
      this.selectParams.billingState.options.push( { text: _state.long, value: _state.short } );
      this.selectParams.shippingState.options.push( { text: _state.long, value: _state.short } );
    });

  }

  ngOnInit ( ) { }

  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'New manufacturer has been added successfully', 
      redirect: '/manufacturers-list' 
    });
  }


  trackByIndex( index: number, obj: any ): any {
    return index;
  }


  addEmail ( ) {
    this.newManufacturer.emails.push( '' );
    this.checkEmail( );
  }

  checkEmail ( ) {
    this.addEmailButtonDisabled = ( this.newManufacturer.emails.indexOf( '' ) !== -1 ) ? true : false;
  }

  removeEmail ( _i: number ) {
    this.newManufacturer.emails.splice( _i, 1 );
    this.checkEmail( );
  }


  errorCallback ( message?: string ) {
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.isSubmitButtonDisabled = false;
  }

  submitForm ( ) {


    this.newManufacturer.memo = $( '#inputMemo' ).html( );

    this.isSubmitButtonDisabled = true;
    this.model.addManufacturer( this.newManufacturer, ( response ) => {
      let _answer = response.json( ).answer;
      
      if ( _answer == 'success' ) this.successCallback( );
      else if ( _answer == 'exists' ) {
        this.errorCallback( 'Manufacturer  with name "' + this.newManufacturer.name + '" already exists' );
        this.global.defaultErrorCallback( 'Manufacturer  with name "' + this.newManufacturer.name + '" already exists' );
      } else {
        this.errorCallback( _answer );
        this.global.defaultErrorCallback( _answer );
      }
    });
    return false;
  }

  cancelSubmit ( ) {
    this.global.redirect( '/manufacturers-list' );
  }
}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/manufacturers/add-manufacturer/add-manufacturer.component.ts